module.exports = __webpack_public_path__ + "static/media/girdhari_parmar_ji_1.4811c8a4.jpg";